import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTenantAuthStore } from '@/store/tenantAuthStore';
import { hasPageAccess } from '@/config/permissions';
import { ROUTES } from '@/config/routes';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  pagePath: string;
}

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ 
  children, 
  pagePath 
}) => {
  const { user, isAuthenticated, isLoading } = useTenantAuthStore();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  const userRoles = user?.roles || [];
  
  if (!hasPageAccess(userRoles, pagePath)) {
    return <Navigate to={ROUTES.FORBIDDEN} replace />;
  }

  return <>{children}</>;
};
